import React from "react";
import Modal, { ModalBody, ModalFooter, ModalHeader } from "../../../components/common/Modal";
const DeleteEntityModal = (props = {}) => {
    const { showDialog = false, toggleDialog, bsClass = '', properties = {}, onCancel, onSubmit } = props
    const { modalTitle = '', par1 = '', cancelBtnText = 'Cancel', submitBtnText = 'Okay' } = properties
    return (
        <Modal
            show={showDialog}
            onClose={toggleDialog}
            bsClass={bsClass}>
            <ModalHeader title={modalTitle}
            />
            <ModalBody>
                <p>{par1}</p>
            </ModalBody>
            <ModalFooter>
                <button
                    className="gdocs-btn-default gdocs-mright-20 gdocs-mtop-20"
                    onClick={onCancel}
                >
                    {cancelBtnText}
                </button>
                <button
                    className="gdocs-btn-primary"
                    onClick={onSubmit}
                >
                    {submitBtnText}
                </button>
            </ModalFooter>
        </Modal>
    );
}

export default DeleteEntityModal


// WEBPACK FOOTER //
// ./src/components/createASow/Modal/index.js